export default {
  header: {
    back: 'return',
    title: 'change password'
  },
  label: {
    resetPay: 'change payment password',
    resetPass: 'change login password',
    oldPasswd: 'old password',
    newPasswd: 'new password',
    reNewPasswd: 'confirm new password',
    bindgoogle: 'google authenticator'
  },
  placeholder: {
    oldPasswd: 'old password',
    newPasswd: 'new password',
    reNewPasswd: 'confirm new password',
    bindgoogle: 'google authenticator'
  },
  rules: {
    oldPasswd: {
      required: 'old password can not be empty！',
      format: 'Incorrect password format！'
    },
    newPasswd: {
      required: 'new password can not be empty！',
      format:
        'The password format is incorrect! The password must contain uppercase and lowercase letters, numbers, special characters (!@#$%^&*_), and the length must be 6 to 25 characters, for example: Abc123!@'
    },
    reNewPasswd: {
      required: 'confirm new password can not be empty！',
      format: 'Incorrect password format！',
      same: 'New passwords and confirm new passwords do not match'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/passwd.js